import { useState } from 'react';

import styled, { css } from 'styled-components';
import { useQuery } from '@tanstack/react-query';
import { ChevronDown } from '@styled-icons/entypo/ChevronDown';

import { ChevronUp } from '@styled-icons/entypo/ChevronUp';

import Seperator from './Seperator';

type DetailItemType = {
  id: null;
  listingFeeSettingId: null;
  type: 'accomodation' | 'fee' | 'tax' | string;
  name: string;
  title: string;
  alias: null;
  quantity: null;
  units: number;
  value: number;
  total: number;
  isIncludedInTotalPrice: 1 | 0;
  isOverriddenByUser: 1 | 0;
  isQuantitySelectable: 1 | 0;
  isMandatory: null;
  isDeleted: 1 | 0;
  displayInRent: 1 | 0;
};

type Props = {
  totalPrice?: String | undefined;
  numNights?: number;
  detailItems?: DetailItemType[];
};

function PriceDetails({ detailItems = [], numNights = 0, totalPrice = '0' }: Props) {
  const [showingPriceDetails, setShowingPriceDetails] = useState(false);
  const baseRate = detailItems.reduce((prev, curr) => {
    if (curr.name === 'baseRate') {
      prev = curr.total;
    }
    return prev;
  }, 0);

  if (!numNights) {
    return null;
  }

  const pricePerNight = numNights ? Math.round(baseRate / numNights) : 0;

  return (
    <PriceDetailsWrapper>
      {showingPriceDetails && (
        <InnerPriceDetailsWrapper>
          <DetailItemList>
            {detailItems.map((item) => {
              return (
                <DetailItem key={item.title}>
                  {item.name === 'baseRate' ? (
                    <PricePerNight>
                      ${`${pricePerNight} x ${String(numNights)} night${numNights > 1 ? 's' : ''}`}
                    </PricePerNight>
                  ) : (
                    <span>{item.title}</span>
                  )}
                  <span>${Math.round(Number(item.total))}</span>
                </DetailItem>
              );
            })}{' '}
          </DetailItemList>
        </InnerPriceDetailsWrapper>
      )}
      <ShowPriceText onClick={() => setShowingPriceDetails(!showingPriceDetails)}>
        Show Price Details {showingPriceDetails ? <StyledChevronUp /> : <StyledChevronDown />}
      </ShowPriceText>
      <StyledSeperator />
      <DetailItemList>
        <TotalPriceWrapper>
          <DetailItem>
            <span>Total Including Taxes</span>
            <span>${Math.round(Number(totalPrice))}</span>
          </DetailItem>
        </TotalPriceWrapper>
      </DetailItemList>
    </PriceDetailsWrapper>
  );
}

const PriceDetailsWrapper = styled.div`
  margin-top: 20px;
  font-family: 'Satoshi';
  max-width: 390px;
  width: 100%;
`;

const ShowPriceText = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`;

const StyledChevronDown = styled(ChevronDown)`
  height: 20px;
  margin-left: 5px;
`;

const StyledChevronUp = styled(ChevronUp)`
  height: 20px;
  margin-left: 5px;
`;

const InnerPriceDetailsWrapper = styled.div``;

const PricePerNight = styled.div`
  /* margin-bottom: 20px; */
`;

const DetailItemList = styled.div``;

const DetailItem = styled.div`
  font-size: 18px;
  line-height: 20px;
  font-weight: 400;
  /* padding-top: 16px; */
  padding-bottom: 16px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

const StyledSeperator = styled(Seperator)`
  margin: 20px 0;
`;

const TotalPriceWrapper = styled.div`
  ${DetailItem} {
    font-weight: 500;
  }
`;

export default PriceDetails;
